var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "web-tab-detail-page" },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [
            {
              title: _vm.$t("webTabsPage.breadcrumbTitle"),
              path: "/integrations/webtabs",
            },
            {
              title: _vm.isEditMode
                ? _vm.$t("webTabsPage.breadcrumbEdit")
                : _vm.$t("webTabsPage.breadcrumbNew"),
            },
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-container" },
        [
          _c("div", { staticClass: "form-header" }, [
            _c("div", { staticClass: "form-header-icon" }, [
              _c(
                "span",
                {
                  staticClass: "material-icons",
                  style: { color: _vm.formData.iconColor || "#6366f1" },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.formData.icon || "tab") +
                      "\n                "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-header-text" }, [
              _c("h1", [
                _vm._v(
                  _vm._s(
                    _vm.isEditMode
                      ? _vm.$t("webTabsPage.formTitleEdit")
                      : _vm.$t("webTabsPage.formTitleNew")
                  )
                ),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("webTabsPage.formSubtitle")))]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.loading } },
            [
              _c(
                "a-form",
                {
                  staticClass: "webtab-form",
                  attrs: { form: _vm.form },
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.handleSubmit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "form-section" }, [
                    _c("div", { staticClass: "section-header" }, [
                      _c("span", { staticClass: "section-number" }, [
                        _vm._v("1"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-title" }, [
                        _c("h3", [
                          _vm._v(
                            _vm._s(_vm.$t("webTabsPage.sectionPlacementTitle"))
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("webTabsPage.sectionPlacementDescription")
                            )
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "placement-grid" },
                      _vm._l(_vm.placementOptions, function (option) {
                        return _c(
                          "a-popover",
                          {
                            key: option.value,
                            attrs: {
                              placement: "right",
                              trigger: "hover",
                              overlayStyle: { maxWidth: "400px" },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "content",
                                  fn: function () {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "placement-popover" },
                                        [
                                          _c("img", {
                                            staticClass: "popover-image",
                                            attrs: {
                                              src: option.previewImage,
                                              alt: option.title,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "popover-title" },
                                            [_vm._v(_vm._s(option.title))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "popover-desc" },
                                            [
                                              _vm._v(
                                                _vm._s(option.longDescription)
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "placement-card",
                                class: {
                                  selected:
                                    _vm.formData.placement === option.value,
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.formData.placement = option.value
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "placement-card-icon",
                                    style: { background: option.color },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v(_vm._s(option.icon))]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "placement-card-content" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "placement-card-title" },
                                      [_vm._v(_vm._s(option.title))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "placement-card-desc" },
                                      [_vm._v(_vm._s(option.description))]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.formData.placement === option.value
                                  ? _c(
                                      "div",
                                      { staticClass: "placement-card-check" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "material-icons" },
                                          [_vm._v("check_circle")]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _vm.formData.placement === "toolbar"
                      ? _c("div", { staticClass: "sub-options" }, [
                          _c(
                            "div",
                            { staticClass: "sub-option-row" },
                            [
                              _c("label", [_vm._v("Açılış Modu")]),
                              _vm._v(" "),
                              _c(
                                "a-radio-group",
                                {
                                  attrs: {
                                    "button-style": "solid",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.formData.toolbarMode,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "toolbarMode", $$v)
                                    },
                                    expression: "formData.toolbarMode",
                                  },
                                },
                                [
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "popup" } },
                                    [_vm._v("Popup")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "parent" } },
                                    [_vm._v("Sayfa")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.formData.toolbarMode === "popup"
                            ? _c(
                                "div",
                                { staticClass: "sub-option-row" },
                                [
                                  _c("label", [
                                    _c("span", [_vm._v("Sürekli Açık Mod")]),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "label-hint" }, [
                                      _vm._v(
                                        "(arka planda çalışmaya devam eder)"
                                      ),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c("a-switch", {
                                    attrs: { size: "small" },
                                    model: {
                                      value: _vm.formData.keepAlive,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "keepAlive", $$v)
                                      },
                                      expression: "formData.keepAlive",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isContactPlacement
                      ? _c("div", { staticClass: "info-badge" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("info"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "Bu yerleşim için kişi bilgilerini URL parametresi olarak kullanabilirsiniz"
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isTableRecordPlacement
                      ? _c("div", { staticClass: "sub-options" }, [
                          _c(
                            "div",
                            { staticClass: "sub-option-row" },
                            [
                              _c("label", [_vm._v("Kapsam")]),
                              _vm._v(" "),
                              _c(
                                "a-radio-group",
                                {
                                  attrs: {
                                    "button-style": "solid",
                                    size: "small",
                                  },
                                  model: {
                                    value: _vm.formData.tableRecordConfig.scope,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.formData.tableRecordConfig,
                                        "scope",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "formData.tableRecordConfig.scope",
                                  },
                                },
                                [
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "all" } },
                                    [_vm._v("Tüm Tablolar")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a-radio-button",
                                    { attrs: { value: "specific" } },
                                    [_vm._v("Belirli Tablo")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.formData.tableRecordConfig.scope === "specific"
                            ? _c(
                                "div",
                                { staticClass: "sub-option-row" },
                                [
                                  _c("label", [_vm._v("Tablo Seçin")]),
                                  _vm._v(" "),
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        placeholder: "Tablo seçin...",
                                        "show-search": "",
                                        size: "small",
                                        "filter-option": _vm.filterTable,
                                      },
                                      model: {
                                        value:
                                          _vm.formData.tableRecordConfig
                                            .tableId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData.tableRecordConfig,
                                            "tableId",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "formData.tableRecordConfig.tableId",
                                      },
                                    },
                                    _vm._l(_vm.tables, function (table) {
                                      return _c(
                                        "a-select-option",
                                        {
                                          key: table._id,
                                          attrs: { value: table._id },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(table.name) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isTableRecordPlacement
                      ? _c("div", { staticClass: "info-badge" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("info"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "Bu yerleşim için tablo ve kayıt bilgilerini URL parametresi olarak kullanabilirsiniz"
                            ),
                          ]),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isTaskDetailPlacement
                      ? _c("div", { staticClass: "info-badge" }, [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("info"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "Bu yerleşim için görev bilgilerini URL parametresi olarak kullanabilirsiniz"
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-section" }, [
                    _c("div", { staticClass: "section-header" }, [
                      _c("span", { staticClass: "section-number" }, [
                        _vm._v("2"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-title" }, [
                        _c("h3", [_vm._v("Kaynak Türü")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("İçeriğin nereden geleceğini belirleyin"),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "type-options" }, [
                      _c(
                        "div",
                        {
                          staticClass: "type-card",
                          class: { selected: _vm.formData.type === "url" },
                          on: {
                            click: function ($event) {
                              _vm.formData.type = "url"
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "type-card-header" }, [
                            _c(
                              "div",
                              { staticClass: "type-card-icon url-icon" },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("link"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.formData.type === "url"
                              ? _c("div", { staticClass: "type-card-check" }, [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("check_circle")]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("h4", [_vm._v("Harici URL")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                                Dışarıdaki herhangi bir web sayfasını embed edin. CRM, dashboard, dokümantasyon veya\n                                herhangi bir web uygulaması olabilir.\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("ul", { staticClass: "type-features" }, [
                            _c("li", [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("check"),
                              ]),
                              _vm._v(" Dinamik parametreler ekleyin"),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("check"),
                              ]),
                              _vm._v(" Kullanıcı/site bilgilerini iletin"),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("check"),
                              ]),
                              _vm._v(" Anında entegrasyon"),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "type-card",
                          class: { selected: _vm.formData.type === "app" },
                          on: {
                            click: function ($event) {
                              _vm.formData.type = "app"
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "type-card-header" }, [
                            _c(
                              "div",
                              { staticClass: "type-card-icon app-icon" },
                              [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("apps"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.formData.type === "app"
                              ? _c("div", { staticClass: "type-card-check" }, [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("check_circle")]
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c("h4", [_vm._v("Web App")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                                Kendi frontend uygulamalarınızı Supsis'de ücretsiz host edin. ZIP dosyası yükleyin\n                                veya Supsis'de AI ile oluşturun.\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("ul", { staticClass: "type-features" }, [
                            _c("li", [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("check"),
                              ]),
                              _vm._v(" Ücretsiz hosting"),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("check"),
                              ]),
                              _vm._v(" React, Vue, HTML/JS desteği"),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("check"),
                              ]),
                              _vm._v(" AI ile uygulama oluşturma"),
                            ]),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.formData.type === "url"
                      ? _c(
                          "div",
                          { staticClass: "type-config" },
                          [
                            _c(
                              "a-input",
                              {
                                attrs: {
                                  placeholder: "https://example.com/dashboard",
                                  size: "large",
                                },
                                model: {
                                  value: _vm.formData.url,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "url", $$v)
                                  },
                                  expression: "formData.url",
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "material-icons",
                                    staticStyle: {
                                      color: "#999",
                                      "font-size": "18px",
                                    },
                                    attrs: { slot: "prefix" },
                                    slot: "prefix",
                                  },
                                  [_vm._v("language")]
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.formData.type === "app"
                      ? _c("div", { staticClass: "type-config" }, [
                          _c(
                            "div",
                            { staticClass: "app-select-wrapper" },
                            [
                              _c(
                                "a-select",
                                {
                                  staticStyle: { flex: "1" },
                                  attrs: {
                                    placeholder: "Web App seçin...",
                                    "show-search": "",
                                    size: "large",
                                    "filter-option": _vm.filterWebApp,
                                  },
                                  model: {
                                    value: _vm.formData.appId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "appId", $$v)
                                    },
                                    expression: "formData.appId",
                                  },
                                },
                                _vm._l(_vm.availableWebApps, function (app) {
                                  return _c(
                                    "a-select-option",
                                    { key: app._id, attrs: { value: app._id } },
                                    [
                                      _c("div", { staticClass: "app-option" }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "material-icons",
                                            style: { color: app.iconColor },
                                          },
                                          [_vm._v(_vm._s(app.icon))]
                                        ),
                                        _vm._v(" "),
                                        _c("span", [_vm._v(_vm._s(app.name))]),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "app-slug" },
                                          [
                                            _vm._v(
                                              _vm._s(app.slug) +
                                                ".webapp.supsis.ai"
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  )
                                }),
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "a-button",
                                {
                                  staticClass: "create-app-btn",
                                  attrs: { type: "primary", ghost: "" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.$router.push(
                                        "/integrations/webapps/new"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "material-icons" },
                                    [_vm._v("add")]
                                  ),
                                  _vm._v(
                                    "\n                                Yeni App Oluştur\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.selectedApp
                            ? _c("div", { staticClass: "selected-app-info" }, [
                                _c("span", { staticClass: "material-icons" }, [
                                  _vm._v("public"),
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "https://" +
                                      _vm._s(_vm.selectedApp.slug) +
                                      ".webapp.supsis.ai"
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-section" }, [
                    _c("div", { staticClass: "section-header" }, [
                      _c("span", { staticClass: "section-number" }, [
                        _vm._v("3"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-title" }, [
                        _c("h3", [_vm._v("Görünüm")]),
                        _vm._v(" "),
                        _c("p", [_vm._v("İsim, ikon ve açıklama ayarlayın")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "appearance-grid" }, [
                      _c("div", { staticClass: "appearance-icon-color" }, [
                        _c(
                          "div",
                          { staticClass: "icon-picker-compact" },
                          [
                            _c("label", [_vm._v("İkon")]),
                            _vm._v(" "),
                            _c("MaterialIconPicker", {
                              model: {
                                value: _vm.formData.icon,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "icon", $$v)
                                },
                                expression: "formData.icon",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "color-picker-compact" }, [
                          _c("label", [_vm._v("Renk")]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "color-input-row" },
                            [
                              _c("color-picker", {
                                model: {
                                  value: _vm.formData.iconColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "iconColor", $$v)
                                  },
                                  expression: "formData.iconColor",
                                },
                              }),
                              _vm._v(" "),
                              _c("a-input", {
                                staticStyle: { width: "90px" },
                                attrs: {
                                  placeholder: "#6366f1",
                                  size: "small",
                                },
                                model: {
                                  value: _vm.formData.iconColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "iconColor", $$v)
                                  },
                                  expression: "formData.iconColor",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "appearance-text" }, [
                        _c(
                          "div",
                          { staticClass: "input-group" },
                          [
                            _c("label", [
                              _vm._v("Menü Adı "),
                              _c("span", { staticClass: "required" }, [
                                _vm._v("*"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("a-input", {
                              attrs: { placeholder: "Örn: CRM Sistemi" },
                              model: {
                                value: _vm.formData.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "name", $$v)
                                },
                                expression: "formData.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "input-group" },
                          [
                            _c("label", [
                              _vm._v("Açıklama "),
                              _c("span", { staticClass: "optional" }, [
                                _vm._v("(tooltip)"),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("a-input", {
                              attrs: { placeholder: "Kısa bir açıklama..." },
                              model: {
                                value: _vm.formData.description,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "description", $$v)
                                },
                                expression: "formData.description",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-section collapsible",
                      class: { expanded: _vm.showQueryParams },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "section-header clickable",
                          on: {
                            click: function ($event) {
                              _vm.showQueryParams = !_vm.showQueryParams
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "section-number" }, [
                            _vm._v("4"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "section-title" }, [
                            _c("h3", [_vm._v("Query Parametreleri")]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "URL'ye dinamik parametreler ekleyin (opsiyonel)"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "material-icons expand-icon" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.showQueryParams
                                    ? "expand_less"
                                    : "expand_more"
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showQueryParams,
                              expression: "showQueryParams",
                            },
                          ],
                          staticClass: "section-content",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "query-params-list" },
                            _vm._l(
                              _vm.formData.queryParams,
                              function (param, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "query-param-row",
                                  },
                                  [
                                    _c("a-input", {
                                      staticStyle: { width: "120px" },
                                      attrs: {
                                        placeholder: "Key",
                                        size: "small",
                                      },
                                      model: {
                                        value: param.key,
                                        callback: function ($$v) {
                                          _vm.$set(param, "key", $$v)
                                        },
                                        expression: "param.key",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "param-equals" },
                                      [_vm._v("=")]
                                    ),
                                    _vm._v(" "),
                                    _c("a-input", {
                                      staticStyle: { flex: "1" },
                                      attrs: {
                                        placeholder: "Value veya ${dinamik}",
                                        size: "small",
                                      },
                                      model: {
                                        value: param.value,
                                        callback: function ($$v) {
                                          _vm.$set(param, "value", $$v)
                                        },
                                        expression: "param.value",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a-select",
                                      {
                                        staticStyle: { width: "180px" },
                                        attrs: {
                                          placeholder: "Dinamik",
                                          size: "small",
                                        },
                                        on: {
                                          change: function (val) {
                                            return _vm.handleDynamicValueChange(
                                              index,
                                              val
                                            )
                                          },
                                        },
                                        model: {
                                          value: param.dynamicValue,
                                          callback: function ($$v) {
                                            _vm.$set(param, "dynamicValue", $$v)
                                          },
                                          expression: "param.dynamicValue",
                                        },
                                      },
                                      [
                                        _c(
                                          "a-select-opt-group",
                                          { attrs: { label: "Manuel" } },
                                          [
                                            _c(
                                              "a-select-option",
                                              { attrs: { value: "" } },
                                              [_vm._v("Manuel")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-select-opt-group",
                                          { attrs: { label: "Kullanıcı" } },
                                          [
                                            _c(
                                              "a-select-option",
                                              {
                                                attrs: {
                                                  value: "${user.name}",
                                                },
                                              },
                                              [_vm._v("Adı")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-select-option",
                                              {
                                                attrs: {
                                                  value: "${user.email}",
                                                },
                                              },
                                              [_vm._v("Email")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-select-option",
                                              {
                                                attrs: { value: "${user.id}" },
                                              },
                                              [_vm._v("ID")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "a-select-option",
                                              {
                                                attrs: {
                                                  value: "${user.token}",
                                                },
                                              },
                                              [_vm._v("Token")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a-select-opt-group",
                                          { attrs: { label: "Site" } },
                                          [
                                            _c(
                                              "a-select-option",
                                              {
                                                attrs: { value: "${site.id}" },
                                              },
                                              [_vm._v("Site ID")]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm.isContactPlacement
                                          ? _c(
                                              "a-select-opt-group",
                                              { attrs: { label: "Kişi" } },
                                              [
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "${contact.id}",
                                                    },
                                                  },
                                                  [_vm._v("ID")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value:
                                                        "${contact.fullname}",
                                                    },
                                                  },
                                                  [_vm._v("Ad Soyad")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "${contact.email}",
                                                    },
                                                  },
                                                  [_vm._v("E-posta")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "${contact.phone}",
                                                    },
                                                  },
                                                  [_vm._v("Telefon")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value:
                                                        "${contact.whatsappNumber}",
                                                    },
                                                  },
                                                  [_vm._v("WhatsApp")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value:
                                                        "${contact.platform}",
                                                    },
                                                  },
                                                  [_vm._v("Platform")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isTableRecordPlacement
                                          ? _c(
                                              "a-select-opt-group",
                                              { attrs: { label: "Tablo" } },
                                              [
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "${table.id}",
                                                    },
                                                  },
                                                  [_vm._v("Tablo ID")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "${table.name}",
                                                    },
                                                  },
                                                  [_vm._v("Tablo Adı")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isTableRecordPlacement
                                          ? _c(
                                              "a-select-opt-group",
                                              { attrs: { label: "Kayıt" } },
                                              [
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "${record.id}",
                                                    },
                                                  },
                                                  [_vm._v("Kayıt ID")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value:
                                                        "${record.recordId}",
                                                    },
                                                  },
                                                  [_vm._v("Kayıt Numarası")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isTableRecordPlacement &&
                                        _vm.selectedTableFields.length > 0
                                          ? _c(
                                              "a-select-opt-group",
                                              {
                                                attrs: {
                                                  label: "Tablo Alanları",
                                                },
                                              },
                                              _vm._l(
                                                _vm.selectedTableFields,
                                                function (field) {
                                                  return _c(
                                                    "a-select-option",
                                                    {
                                                      key: field._id,
                                                      attrs: {
                                                        value:
                                                          "${field." +
                                                          field._id +
                                                          "}",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(field.name) +
                                                          "\n                                        "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isTaskDetailPlacement
                                          ? _c(
                                              "a-select-opt-group",
                                              { attrs: { label: "Görev" } },
                                              [
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "${task.id}",
                                                    },
                                                  },
                                                  [_vm._v("Görev ID")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "${task.title}",
                                                    },
                                                  },
                                                  [_vm._v("Görev Başlığı")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value:
                                                        "${task.description}",
                                                    },
                                                  },
                                                  [_vm._v("Görev Açıklaması")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "${task.priority}",
                                                    },
                                                  },
                                                  [_vm._v("Öncelik")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value:
                                                        "${task.startDate}",
                                                    },
                                                  },
                                                  [_vm._v("Başlangıç Tarihi")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "${task.endDate}",
                                                    },
                                                  },
                                                  [_vm._v("Bitiş Tarihi")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value:
                                                        "${task.completed}",
                                                    },
                                                  },
                                                  [_vm._v("Tamamlandı mı")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "${task.done}",
                                                    },
                                                  },
                                                  [_vm._v("Done Durumu")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value:
                                                        "${task.pipelineStage}",
                                                    },
                                                  },
                                                  [_vm._v("Aşama ID")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "${task.workflow}",
                                                    },
                                                  },
                                                  [_vm._v("Workflow ID")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isTaskDetailPlacement
                                          ? _c(
                                              "a-select-opt-group",
                                              {
                                                attrs: {
                                                  label: "Görev Sahibi",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value: "${task.owner.id}",
                                                    },
                                                  },
                                                  [_vm._v("Sahip ID")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value:
                                                        "${task.owner.name}",
                                                    },
                                                  },
                                                  [_vm._v("Sahip Adı")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value:
                                                        "${task.owner.email}",
                                                    },
                                                  },
                                                  [_vm._v("Sahip Email")]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.isTaskDetailPlacement
                                          ? _c(
                                              "a-select-opt-group",
                                              {
                                                attrs: {
                                                  label: "Görev Atananlar",
                                                },
                                              },
                                              [
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value:
                                                        "${task.assignees}",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Atananlar (ID listesi)"
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a-select-option",
                                                  {
                                                    attrs: {
                                                      value:
                                                        "${task.assigneesNames}",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "Atananlar (İsim listesi)"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "a-button",
                                      {
                                        staticClass: "remove-param-btn",
                                        attrs: { type: "link", size: "small" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeQueryParam(index)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "material-icons" },
                                          [_vm._v("close")]
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _c(
                            "a-button",
                            {
                              staticClass: "add-param-btn",
                              attrs: { type: "dashed", size: "small" },
                              on: { click: _vm.addQueryParam },
                            },
                            [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("add"),
                              ]),
                              _vm._v(
                                "\n                            Parametre Ekle\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "form-section collapsible",
                      class: { expanded: _vm.showAdvanced },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "section-header clickable",
                          on: {
                            click: function ($event) {
                              _vm.showAdvanced = !_vm.showAdvanced
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "section-number" }, [
                            _vm._v("5"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "section-title" }, [
                            _c("h3", [_vm._v("Diğer Ayarlar")]),
                            _vm._v(" "),
                            _c("p", [_vm._v("Görünürlük, sıralama ve durum")]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "material-icons expand-icon" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.showAdvanced
                                    ? "expand_less"
                                    : "expand_more"
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showAdvanced,
                              expression: "showAdvanced",
                            },
                          ],
                          staticClass: "section-content",
                        },
                        [
                          _c("div", { staticClass: "advanced-grid" }, [
                            _c(
                              "div",
                              { staticClass: "advanced-item" },
                              [
                                _c("label", [_vm._v("Sıralama")]),
                                _vm._v(" "),
                                _c("a-input-number", {
                                  staticStyle: { width: "80px" },
                                  attrs: { min: 0, size: "small" },
                                  model: {
                                    value: _vm.formData.order,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "order", $$v)
                                    },
                                    expression: "formData.order",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "hint" }, [
                                  _vm._v("Düşük = önce"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "advanced-item" },
                              [
                                _c("label", [_vm._v("Durum")]),
                                _vm._v(" "),
                                _c(
                                  "a-switch",
                                  {
                                    attrs: { size: "small" },
                                    model: {
                                      value: _vm.formData.enabled,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "enabled", $$v)
                                      },
                                      expression: "formData.enabled",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "checkedChildren" },
                                        slot: "checkedChildren",
                                      },
                                      [_vm._v("Aktif")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "unCheckedChildren" },
                                        slot: "unCheckedChildren",
                                      },
                                      [_vm._v("Pasif")]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "visibility-section" },
                            [
                              _c("label", [_vm._v("Görünürlük")]),
                              _vm._v(" "),
                              _c("VisibilityChanger", {
                                attrs: {
                                  "show-title": false,
                                  "alert-message": false,
                                  "hide-owner-section": true,
                                  isChannel: false,
                                },
                                model: {
                                  value: _vm.formData.visibility,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formData, "visibility", $$v)
                                  },
                                  expression: "formData.visibility",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-actions" },
                    [
                      _c(
                        "a-button",
                        {
                          attrs: { size: "large" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/integrations/webtabs")
                            },
                          },
                        },
                        [_vm._v(" İptal ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "large",
                            "html-type": "submit",
                            loading: _vm.saving,
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v(_vm._s(_vm.isEditMode ? "save" : "add")),
                          ]),
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.isEditMode ? "Güncelle" : "Oluştur") +
                              "\n                    "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }